import {useEffect,useRef} from 'react';
import {X} from 'lucide-react';
import {formatReadexUserPrompt,type ReadexPromptPDFOutlineContext} from '@reados/contracts';
import '../pdf-outline-attachments.css';

export function PdfOutlineContextPreview({context,fileName,onClose,onOpen}:{context:ReadexPromptPDFOutlineContext;fileName:string;onClose:()=>void;onOpen?:()=>void}){
 const dialog=useRef<HTMLDialogElement>(null);
 useEffect(()=>{const previous=document.activeElement instanceof HTMLElement?document.activeElement:null;dialog.current?.showModal();return()=>{dialog.current?.close();if(previous?.isConnected)previous.focus({preventScroll:true});};},[]);
 return <dialog ref={dialog} className="pdf-outline-context-dialog" aria-label="目录附件预览" onCancel={onClose}>
  <header><h2>目录附件</h2><button className="icon-button" type="button" aria-label="关闭目录附件预览" onClick={onClose}><X size={18}/></button></header>
  <div className="pdf-outline-context-body">
   <p className="pdf-outline-context-source">{fileName}</p>
   <OutlinePreviewNode node={context.selectedNode}/>
   <p className="pdf-outline-context-note">已附加所选目录及其子目录范围。发送时会核对 PDF 和目录；PDF 内容由 Readex 按需读取。</p>
   {onOpen&&<button className="secondary" type="button" onClick={()=>{onClose();onOpen();}}>打开 PDF</button>}
   <details><summary>查看结构化上下文</summary><pre>{formatReadexUserPrompt('',[],[context])}</pre></details>
  </div>
 </dialog>;
}
function OutlinePreviewNode({node}:{node:ReadexPromptPDFOutlineContext['selectedNode']}){
 return <div className="pdf-outline-context-node"><strong>{node.title}</strong><small>书本页码 {node.bookPageRange}</small>{Boolean(node.children?.length)&&<ul>{node.children!.map((child,index)=><li key={index}><OutlinePreviewNode node={child}/></li>)}</ul>}</div>;
}
